import React from 'react';
import { PartnerFormFieldsNames } from '@/modules/Partners/helpers/types';
import { Input } from '@/ui';
import { FormItem } from '@/components';
import { usePartnerFormRules } from '@/modules/Partners/hooks';
import { useTranslation } from 'react-i18next';

interface ITaxCodeField {
  kind: 'edrpou' | 'drfo' | 'ipn';
  required: boolean;
}

const TaxCodeField = ({ kind, required }: ITaxCodeField) => {
  const rules = usePartnerFormRules();
  const { t } = useTranslation(['partners']);
  const fields = {
    edrpou: { name: PartnerFormFieldsNames.TAX_CODE, label: 'partners_tax_code', rules: rules.organization_tax_code },
    drfo: { name: ['companyDraft', 'drfo'], label: 'partners_drfo', rules: rules.drfo },
    ipn: { name: PartnerFormFieldsNames.IPN, label: 'partners_ipn', rules: rules.ipn },
  };
  const field = fields[kind];

  return (
    <FormItem name={field.name} label={t(field.label)} rules={required ? field.rules : field.rules.slice(1)}>
      <Input inputMode="numeric" />
    </FormItem>
  );
};

export default TaxCodeField;
